module.exports = __webpack_public_path__ + "img/logo_name.9665a975.png";